import { useNavigate, useParams } from 'react-router-dom'

import { useCMS } from '@tribeplatform/react-components/CMS'
import { EntityImage } from '@tribeplatform/react-components/common/components'
import { IconButton } from '@tribeplatform/react-ui-kit/Button'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const PostTypeBlocksSidebarTitle = () => {
  const { postTypeId } = useParams<{ postTypeId: string }>()
  const { postTypes } = useCMS()
  const navigate = useNavigate()
  const postType = postTypes.find(({ id }) => id === postTypeId)

  if (!postType) {
    return null
  }

  const { icon, name, slug } = postType

  return (
    <div className="flex justify-between items-center">
      <div className="space-x-2 flex items-center flex-1 min-w-0 ">
        <EntityImage entity={{ image: icon, name }} size="lg" />
        <div className="truncate">{name}</div>
      </div>
      <IconButton
        icon={<SvgIcon name="settings" />}
        size="lg"
        variant="tertiaryNeutral"
        onClick={() => navigate(`/manage/content/cms/${slug}`)}
      />
    </div>
  )
}
